import { Button, DropdownMenu, DropdownMenuItem, Icon } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { AudienceSourceType } from '../../models';
import { IApplicationState } from '../../store';
import { ActionCreators as AudienceActionCreators } from '../../store/AudienceDetailsStore';
import { NavigationHelper } from '../../utilities/NavigationHelper';
import { AudienceMode } from './AudienceMode';

const DropdownContainer = styled.div`
	position: absolute;
	display: initial;
`;

const downArrow: React.CSSProperties = {
	fontSize: '8px',
	left: '10px',
	position: 'relative',
};

type AddAudienceButtonProps = {
	surveyId: number;
	mode: AudienceMode;
	disabled?: boolean;
	dropdownPositionX: number;
	dropdownPositionY: number;
};

export const AddAudienceButton = (props: AddAudienceButtonProps) => {
	const dispatch = useDispatch();

	const { audienceSourceType } = useSelector((state: IApplicationState) => state.survey.surveyEditModel.survey);

	const [isDropdownOpen, setDropdown] = useState<boolean>(false);
	const { dropdownPositionX, dropdownPositionY, disabled } = props;

	const canUserAccessCopyAudience = audienceSourceType !== AudienceSourceType.Hierarchy;

	function RenderAudienceButton(onClick: () => void, isDropdown = true) {
		return (
			<Button onClick={onClick} id='AddAudience' color='primary' size='large' disabled={disabled}>
				{ContentConstants.BUTTONS_ADD_NEW_AUDIENCE}
				{isDropdown && <Icon name='caret-down' style={downArrow} />}
			</Button>
		);
	}

	function Dropdown() {
		return (
			<>
				{RenderAudienceButton(() => setDropdown(!isDropdownOpen))}
				<DropdownContainer>
					<DropdownMenu open={isDropdownOpen} x={dropdownPositionX} y={dropdownPositionY}>
						<DropdownMenuItem onClick={() => addNewAudience(false)}>{ContentConstants.ACTIONMENU_ACTIVE}</DropdownMenuItem>
						<DropdownMenuItem onClick={() => addNewAudience(true)}>{ContentConstants.ACTIONMENU_TEST}</DropdownMenuItem>
					</DropdownMenu>
				</DropdownContainer>
			</>
		);
	}

	return <>{canUserAccessCopyAudience ? Dropdown() : RenderAudienceButton(() => addNewAudience(false), false)}</>;

	function addNewAudience(isTestAudience: boolean) {
		dispatch(AudienceActionCreators.SetTestAudience(isTestAudience));
		dispatch(NavigationHelper.GoToAudienceDetails(props.surveyId, props.mode));
	}
};
